module.exports = __webpack_public_path__ + "img/home-hero-mobile-894dfc6.jpg";